import Esami from "../";

const routes = [
  { name: "SpirometriaList", path: "/paziente/esami/spirometria/", component: Esami.Spirometria.SpirometriaList, meta: { title: "Spirometria"}},
  { name: "SpirometriaEdit", path: "/paziente/esami/spirometria/edit/:id", component: Esami.Spirometria.SpirometriaEdit, meta: { title: "Spirometria"}},
  { name: "SpirometriaView", path: "/paziente/esami/spirometria/view/:id", component: Esami.Spirometria.SpirometriaView, meta: { title: "Spirometria"}},

];
export default routes;
